import { useMemo } from "react";
import styled from "styled-components";
import {
  BASIC_DARK_GRAY,
  BASIC_LIGHT_GRAY,
  BASIC_ORANGE,
} from "../../../constants/colors";
import { Campaign } from "../../../ducks/campaign";
import {
  formatDate,
  getDatePlusDays,
  getDatesInRange,
  getUTCDatePlusMinutes,
} from "../../../utils/date";
import { DatePicker } from "../../atoms/DatePicker";
import { Select } from "../../atoms/Select";

type Props = {
  onChange: (date: string) => void;
  selectedDate: string;
  campaign: Campaign | null;
};

export const PickUpDateSelect: React.FC<Props> = ({
  onChange,
  selectedDate,
  campaign,
}) => {
  const selectableDates = useMemo(() => {
    return getDatesInRange(new Date(), getDatePlusDays(new Date(), 6)).map(
      (date, i) => ({
        id: i,
        name: formatDate(date, true, "M/D"),
        value: getUTCDatePlusMinutes(date, 0),
      }),
    );
  }, []);

  const isEarlyBird = useMemo(() => {
    return !!campaign;
  }, [campaign]);

  return (
    <div>
      <PickUpDateContainer $isEarlyBird={isEarlyBird}>
        <PickUpDateSelectTextContainer>
          <PickUpDateSelectText>
            お受け取り日を
            {!isEarlyBird && <br />}
            指定してください。
          </PickUpDateSelectText>
        </PickUpDateSelectTextContainer>

        <PickUpDateSelectContainer $isEarlyBird={isEarlyBird}>
          {isEarlyBird ? (
            <DatePicker
              value={campaign?.minSaleStartDate}
              onChange={(date) => onChange(date.toString())}
              minDate={campaign?.minSaleStartDate}
              maxDate={campaign?.maxSaleEndDate}
              displayFormat="M/D (ddd)"
            />
          ) : (
            <Select
              name="pickUpDate"
              defaultValue={
                selectedDate
                  ? formatDate(selectedDate, true, "M/D")
                  : selectableDates[0].name
              }
              options={selectableDates}
              onChange={(name, value) => onChange(value)}
              size="sm"
              clearable={false}
            />
          )}
        </PickUpDateSelectContainer>
      </PickUpDateContainer>

      <DeliveryAttentionTextContainer>
        <DeliveryAttentionText>
          ※ご注文確定のお時間によっては、お受け取り日時がご選択いただいたお時間より変更となってしまう場合がございます。
        </DeliveryAttentionText>
      </DeliveryAttentionTextContainer>
    </div>
  );
};

const PickUpDateContainer = styled.div<{ $isEarlyBird: boolean }>`
  background-color: ${BASIC_LIGHT_GRAY};
  display: flex;
  flex-direction: ${(p) => (p.$isEarlyBird ? "column" : "row")};
  padding: 20px 16px 0 16px;
`;

const PickUpDateSelectTextContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;

const PickUpDateSelectText = styled.p`
  margin: 0;
  padding: 0;
  text-align: left;
  font-weight: 600;
  color: ${BASIC_DARK_GRAY};
  font-size: 16px;
  line-height: 1.6em;
`;

const PickUpDateSelectContainer = styled.div<{ $isEarlyBird: boolean }>`
  flex: 1;
  padding: ${(p) => (p.$isEarlyBird ? "16px 0" : "0")};
`;

const DeliveryAttentionTextContainer = styled.div`
  background-color: ${BASIC_LIGHT_GRAY};
  padding: 0 0 0 0;
`;

const DeliveryAttentionText = styled.p`
  text-align: left;
  margin: 0;
  font-weight: 300;
  padding: 10px 20px 20px 20px;
  font-size: 14px;
  color: ${BASIC_ORANGE};
`;
